import PropTypes from "prop-types";
import React from "react";
import {H2} from "BaseComponents/Text";
import {PagePuffContainer, PagePuffOuterWrapper, PagePuffText, PagePuffWrapper,} from "./components/";
import {ButtonText, ColoredButton} from "BaseComponents/Button";
import LazyBackgroundImage from "Framework/lazy/LazyBackgroundImage";
import LazyImage from "Framework/lazy/LazyImage";
import {Image} from "BaseComponents/Image";
import {HeaderLink} from "BaseComponents/Link";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {GetButtonColor, GetTextColor} from "Helpers/ColorHelper";
import styled, {css} from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {BlockContainer} from "BaseComponents/Wrappers";

export const PagePuff = ({
                             ListHeadline,
                             ListImage,
                             Url,
                             ListPreamble,
                             ImgToTheLeft,
                             ListButtonHeading,
                             BackgroundColor,
                             ResponsiveImage,
                             ImageFullHeight,
                             ButtonColor,
                         }) => {
    let responsiveImage = getResponsiveImage(ResponsiveImage);
    const {textColor} = GetTextColor(BackgroundColor);
    const {color: buttonColor, textColor: buttonTextColor} =
        GetButtonColor(ButtonColor);

    return (
        <BlockContainer>
            <PagePuffOuterWrapper bgColor={BackgroundColor} className="pagePuffWrapper">
                <PagePuffContainer
                    className="page-puff"
                    smallpadding={ImageFullHeight ? "0" : "1rem 1rem"}
                >
                    <PagePuffWrapper
                        smallwidth="auto"
                        padding={ImageFullHeight ? "0" : "3rem 1rem"}
                        margin="0 auto"
                        alignItems={ImageFullHeight ? "stretch" : "center"}
                        justifycontent="space-between"
                        flexdir={ImgToTheLeft ? "row-reverse" : "row"}
                        smallflexdirection="column-reverse"
                        autoWidth={true}
                        imgFullHeight={ImageFullHeight}
                        smallpadding={ImageFullHeight ? "0" : "1rem"}
                    >
                        <PagePuffWrapper
                            justifycontent="center"
                            column={true}
                            padding={
                                ImageFullHeight
                                    ? "4.5rem 0rem 4.625rem 0rem"
                                    : "1.5rem 0rem 0 0rem"
                            }
                            smallpadding="1rem 0 0 0"
                            flex={ImageFullHeight ? "1" : "1 40%"}
                            flexgrow={ImageFullHeight ? "1" : "0"}
                        >
                            <FullImageHeightSpan
                                padding={
                                    ImageFullHeight
                                        ? ImgToTheLeft
                                            ? "0 59px 0 64px;"
                                            : "0 64px 0 59px;"
                                        : undefined
                                }
                            >
                                <H2
                                    smallFontSize={ImageFullHeight ? "32px" : undefined}
                                    smallLineHeight={ImageFullHeight ? "38px" : undefined}
                                    fontWeight={ImageFullHeight ? "600" : undefined}
                                    color={textColor}
                                >
                                    {ListHeadline}
                                </H2>
                                <PagePuffText
                                    color={textColor}
                                    margin="1rem 0"
                                    large
                                    fontSizeSmall={ImageFullHeight ? "18px" : undefined}
                                    marginSmall={ImageFullHeight ? "8px 0 0 0" : "0"}
                                    display={ImageFullHeight ? "block" : undefined}
                                >
                                    {ListPreamble}
                                </PagePuffText>
                                {ImageFullHeight ? (
                                    <ColoredButton
                                        href={Url}
                                        inverted
                                        bgColor={buttonColor}
                                        colorhover={buttonTextColor}
                                        widthsmall="100%"
                                        width="auto"
                                        display="inline-block"
                                        color="black"
                                        margin="16px 0 0 0"
                                        smallmargin="24px 0 0 0 "
                                        padding="7.5px 58.5px"
                                        smallpadding="3.5px 0"
                                        aria-label={ListHeadline}
                                        borderradius="21px"
                                    >
                                        <ButtonText
                                            color={buttonTextColor}
                                            fontWeight="700"
                                            textTransform="uppercase"
                                            heading={ListHeadline}
                                        >
                                            {ListButtonHeading}
                                        </ButtonText>
                                    </ColoredButton>
                                ) : (
                                    <HeaderLink
                                        inverted
                                        width="fit-content"
                                        margin="2rem 0"
                                        href={Url}
                                        text={ListButtonHeading}
                                        ariaLabel={ListHeadline}
                                        color={textColor}
                                    />
                                )}
                            </FullImageHeightSpan>
                        </PagePuffWrapper>
                        <PagePuffWrapper
                            justifycontent="center"
                            padding="0"
                            alignItems="stretch"
                            smallpadding="0"
                            flex={ImageFullHeight ? "1" : "1 43.5%"}
                            flexgrow={ImageFullHeight ? "1" : "0"}
                        >
                            {Image &&
                                (ImageFullHeight ? (
                                    <LazyImage
                                        source={responsiveImage}
                                        height="100%"
                                        display="flex"
                                    />
                                ) : (
                                    <LazyBackgroundImage
                                        maxHeight={ImageFullHeight ? "800px" : "303px"}
                                        height="100%"
                                        source={responsiveImage}
                                    />
                                ))}
                        </PagePuffWrapper>
                    </PagePuffWrapper>
                </PagePuffContainer>
            </PagePuffOuterWrapper>
        </BlockContainer>);
};

PagePuff.propTypes = {
    ListHeadline: PropTypes.string,
    ListImage: PropTypes.object,
    ListPreamble: PropTypes.string,
    ImgToTheLeft: PropTypes.bool,
    Url: PropTypes.string,
};
export const FullImageHeightSpan = styled.span.attrs(
    ({padding, smallpadding}) => ({
        padding: padding,
        smallpadding: smallpadding ? smallpadding : "0px 16px 48px 16px",
    })
)`
  ${({padding}) =>
    padding &&
    css`
      padding: ${({padding}) => padding};
    `}
  ${media.lessThan(breakpoints.ipad)`		
		padding: ${({smallpadding}) => smallpadding};
  `};
`;
